/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_DashboardInputs */

const id_portal_dashboard = /** @type {(inputs: Portal_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasbor`)
};

const en_portal_dashboard = /** @type {(inputs: Portal_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Portal_DashboardInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_dashboard = /** @type {((inputs?: Portal_DashboardInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_DashboardInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_dashboard(inputs)
	return id_portal_dashboard(inputs)
});